import axios from "../config";

export const getAttachmentById = async (id) => {
  const response = await axios.get(`attachment/${id}`, {
    responseType: "blob",
  });

  if (response.data) {
    return URL.createObjectURL(new Blob([response.data]));
  }
  return null;
};

// Uploads one file through the shared attachment endpoint; resolves to the attachment id.
export const uploadAttachment = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axios.post("attachment", formData);
  return response.data.id;
};
